import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Dialog, { DialogContent } from '@eversports/klimt-primitives/legacy/Dialog'

import FullscreenDialog from '../../../../../components/FullscreenDialog'
import { Localized } from '../../../../../localization/react'
import { PublicUser } from '../../../ActivityDetails.types'

import AllParticipatingFriendsContent from './AllParticipatingFriendsContent'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
  friends: Array<PublicUser>
}

const AllParticipatingFriends = ({ isOpen, toggleDialog, friends }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return isMobile ? (
    <FullscreenDialog title={<Localized id="friends-attending-section-title" />} isOpen={isOpen} onClose={toggleDialog}>
      <AllParticipatingFriendsContent friends={friends} />
    </FullscreenDialog>
  ) : (
    <Dialog open={isOpen} onClose={toggleDialog}>
      <DialogContent sx={{ height: '672px', padding: 0 }}>
        <AllParticipatingFriendsContent friends={friends} />
      </DialogContent>
    </Dialog>
  )
}

export default AllParticipatingFriends
